
// Desktop Dropdowns
function hideActiveDropdowns (){
  $(this).removeClass('active')
  $(this).children('.nav__sub-wrapper').slideUp()
}

function showDropdown (nav, sub_nav){
  nav.addClass('active')
  sub_nav.stop( true, true ).slideDown()
}

function hideDropdown (nav, sub_nav) {
  nav.removeClass('active')
  sub_nav.stop( true, true ).slideUp()
}

// Mobile Dropdowns
function toggleActive(nav, sub_nav){
  nav.toggleClass('active')
  sub_nav.slideToggle()
}

function handleHamburger () {
  $('.site-header__hamburger .hamburger').click(function(){
    $(this).toggleClass("is-active")
    $('.mobile-nav-wrapper, body').toggleClass('js-menu--is-open')
  })
}

// Nav Functions
function checkScroll(){
  // Changes opacity of nav to 1 on scroll
  const startY = $('.site-header').height() * 1;
  if($(window).scrollTop() > startY){
    $('.site-header').addClass("scrolled");
  }else{
    $('.site-header').removeClass("scrolled");
  }
}


const header = {
  init: () => {
    $('.js-slider.announcement-bar__wrapper.js-slider--desk').slick({
      autoplay: true,
      speed: 600,
      dots: false,
      arrows: false,
      adaptiveHeight: true
    });
    let announcement_delay = 13000;
    $('.js-slider.announcement-bar__wrapper.js-slider--mob').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 0,
      adaptiveHeight: true,
      speed: announcement_delay,
      draggable: false,
      pauseOnHover: true,
      pauseOnFocus: true
    });
    handleHamburger()

    $(window).on("scroll load resize", function(){
      checkScroll();
    });

    if(!$("body").hasClass("template-index")) {
      $(window).on("scroll load", function(){
        calcNavHeight();
      });
    }
    // Mobile Dropdowns
    $('.js-toggle-submenu.mobile-nav__link').each(function(){
      const nav = $(this),
          sub_nav = $(this).next('.mobile-nav__dropdown');
      nav.click(function(){
        toggleActive(nav, sub_nav);
      })
    })


    // Desktop Dropdowns
    $('.site-nav--has-dropdown').each(function(){
      const sub_nav = $(this).children('.site-nav__dropdown'),
        nav = $(this);
      nav.on('mouseenter touchstart', function(){
        nav.siblings('.active').each(hideActiveDropdowns)
        showDropdown(nav, sub_nav)
      })

      nav.on('mouseleave touchstart',function(event){
        hideDropdown(nav, sub_nav)
      })
    })
       }
};
export default header;
